angular
    .module('annexaApp')
    .component('annexaBoxRegisterSettlementPaginated',{
        templateUrl: './components/reg/annexa-box-register-settlement-paginated/annexa-box-register-settlement-paginated.html',
        controller:['$q', 'DccumentsFactory', '$rootScope', 'AnnexaObjectBoxFactory', '$scope', 'Language', '$filter', 'AnnexaFormlyFactory', 'GlobalDataFactory', 'DialogsFactory', 'AnnexaEntityFactory', 'TramNewFactory', 'AnnexaPermissionsFactory', 
		function($q, DccumentsFactory, $rootScope, AnnexaObjectBoxFactory, $scope, Language, $filter, AnnexaFormlyFactory, GlobalDataFactory, DialogsFactory,AnnexaEntityFactory, TramNewFactory, AnnexaPermissionsFactory) {
            var vm = this;
            vm.languageColumn = Language.getActiveColumn();
            
            this.$onInit = function() {
            	if(vm.box && vm.box.tableDefinition){
					vm.regModule = $linq(GlobalDataFactory.modules).where("x => x.url == 'annexa.reg.input'").toArray();
	                
	            	if(!vm.boxTitle) {
	                    vm.boxTitle = 'global.taxBlock.settlements';
	            	}
				}
            	if(vm.box && $rootScope && $rootScope.app && $rootScope.app.configuration && $rootScope.app.configuration.settlement_properties_active && $rootScope.app.configuration.settlement_properties_active.active){
        			vm.box.legend = [];
            		var legend = $rootScope.app.configuration.settlement_properties_active.settlementStatus;
            		if(legend && legend.length > 0){
            			_.forEach(legend, function(l){
            				l.name = l[vm.languageColumn];
            			});
            		}
            		vm.box.legend = legend;
            	}
            }
        }],
        bindings: {
            box: '='
        }
    })